import AuthenticationMethodAccordion from './AuthenticationMethodAccordion';

export default AuthenticationMethodAccordion;
